<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div>
          <div class="btn" @click="handleModal('add')">+ 添加标签名</div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          highlight-current-row
          :header-cell-style="{
            color: '#333',
            background: '#FAFAFA',
            borderBottom: '1px solid #E8E8E8',
            height: '44px',
          }"
          :row-style="{
            height: '44px',
          }"
        >
          <el-table-column
            prop="created"
            align="center"
            label="日期"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="标签名(中)"
          ></el-table-column>
          <el-table-column
            prop="dataName"
            align="center"
            label="标签名(英)"
          ></el-table-column>
          <el-table-column prop="open" align="center" label="启用状态">
            <div slot-scope="scope">
              {{ openMap[scope.row.open] }}
            </div>
          </el-table-column>
          <el-table-column prop="open" align="center" label="设为筛选条件">
            <!-- <div slot-scope="scope" @click="changeLabelFilter(scope.row)">
              <el-switch
                v-model="scope.row.filter"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
              >
              </el-switch>
              {{ openMap[scope.row.filter] }}
            </div> -->
            <div
              slot-scope="scope"
              @click="changeLabelFilter(scope.row.id, scope.row.filter)"
            >
              <i
                v-if="scope.row.filter === 1"
                class="iconfont icon-xuanzye checked-icon"
                style="color: #6B95FF;"
              ></i>
              <i v-else class="iconfont icon-weixzye"></i>
              {{ scope.row.filter === 1 ? '是' : '否' }}
            </div>
          </el-table-column>
          <el-table-column
            prop="desc"
            align="center"
            label="描述"
          ></el-table-column>
          <el-table-column prop="lock" align="center" label="控制锁">
            <div slot-scope="scope">
              {{ lockMap[scope.row.lock] }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="toItem(scope.row.id, scope.row.dataName)"
              >
                详情
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleModal('edit', scope.row)"
              >
                变更
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleDelete(scope.row.id)"
              >
                删除
              </button>
              <button
                size="mini"
                v-if="scope.row.lock === 1"
                class="table-btn"
                @click="handleLock(scope.row.id)"
              >
                控制锁
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="560px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新增" : "变更") + "标签名" }}
      </div>
      <el-form ref="form" :model="form" class="form" label-width="auto">
        <el-form-item label="标签名称(中)：" prop="name" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签名称(中)"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签名称(英)：" prop="dataName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签名称(英)"
            v-model="form.dataName"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态：" prop="dataName" class="form-item">
          <el-switch
            v-model="form.open"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="描述：" prop="desc" class="form-item">
          <el-input
            size="small"
            placeholder="描述"
            v-model="form.desc"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '标签名管理'
      },
      openMap: {
        1: '是',
        2: '否'
      },
      lockMap: {
        1: '未开启',
        2: '已开启，该项不能随意修改',
      },
      list: [],
      total: 0,
      type: '',
      visible: false,
      form: {
        name: '',
        dataName: '',
        desc: '',
        open: 1
      },
      id: null
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getLabelList, {}).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    toItem(id, dataName){
      this.$router.push({
        name: 'labelItem',
        query: { id, dataName }
      });
    },
    // 编辑轮播弹窗
    handleModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.id = rowData.id;
        this.form = {
            name: rowData.name,
            dataName: rowData.dataName,
            desc: rowData.desc,
            open: rowData.open
        };
      } else {
        this.form = {
            name: '',
            dataName: '',
            desc: '',
            open: 1
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.visible = true;
    },
    changeLabelFilter(id, filter) {
      let str = '';
      if(filter === 1){
        str = '取消';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}设置该标签为筛选条件？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.changeLabelFilter, {
          id,
          filter: filter === 1 ? 2 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除轮播图
    handleDelete(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该标签吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteLabel, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleLock(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确认后,该项数据不能更改,且操作不可逆, 确认锁定吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.lockLabel, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addLabel
              : this.$root.updateLabel;
          let method = this.type === 'add' ? 'httpPost' : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.form
                }
              : {
                  ...this.form,
                  id: this.id
                };
          this.loading++;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.visible = false;
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    // content 表格
    .content {
      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .form {
    padding: 12px 24px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
